import { getFirebaseBackend } from 'helpers/firebaseHelper';
import { formatDateTimestampNumber } from 'utils/formatDateTimestampNumber';

const { parse } = require('json2csv');

const handleDownloadMeetingCSV = async (accountId) => {
  const firebaseHelper = getFirebaseBackend();

  try {
    const response = await firebaseHelper.getAllMeetings(accountId);
    const allMeetings = Object.values(response);

    const meetingsPromises = allMeetings.map(async (meeting) => {
      let participants = '';

      if (meeting.participants && meeting.participants.length > 0) {
        const userPromises = meeting.participants.map(async (userId) => {
          if (userId.includes('external')) {
            return;
          }

          const username = await firebaseHelper.getUserName(userId);
          return username;
        });
        const resolvedUserNames = await Promise.all(userPromises);
        participants = resolvedUserNames.join(',');
      }

      const steps = await Promise.all(
        (meeting.steps || []).map(async (step) => {
          let assigneeName = step.assignedTo;
          if (assigneeName && !assigneeName.includes('external')) {
            try {
              assigneeName = await firebaseHelper.getUserName(step.assignedTo);
            } catch (err) {
              console.warn(`Failed to get name for assignedTo: ${step.assignedTo}`, err);
            }
          }
          return `${assigneeName} - ${step.step}`;
        }),
      );

      return {
        Agenda: meeting.agenda,
        Date: formatDateTimestampNumber(meeting.date, 'date-enUS'),
        Participants: participants,
        Description: meeting.description,
        Minutes: meeting.minutes,
        Steps: steps.join(' | '),
      };
    });

    const resolvedMeetings = await Promise.all(meetingsPromises);

    const csvOptions = {
      fields: ['Agenda', 'Date', 'Description', 'Minutes', 'Steps', 'Participants'],
      header: true,
    };

    const csvContent = parse(resolvedMeetings, csvOptions);

    const blob = new Blob([csvContent], { type: 'text/csv' });

    const url = URL.createObjectURL(blob);
    const accountName = await firebaseHelper.accountName(accountId);
    const dateNumber = new Date().toISOString().substring(0, 10);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${accountName}_${dateNumber}_meetings_data.csv`;

    link.click();

    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading CSV:', error);
  }
};

export { handleDownloadMeetingCSV };
